<template>
  <div v-if="!isPrint">
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        // { type: 'sign', label: '서명' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 청소·조도·통로 등 -->
    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="청소·조도·통로 등"
      table-header-title="점검항목"
      table-header-yes="양호"
      table-header-no="불량"
      table-header-na="N/A"
      table-header-note="비고(조치결과)"
      tableTitleColor="white"
      contentBefore="•"
      v-model="form.inspectList"
      class="mt-5"
    />

    <!-- 확인자-->
    <h5 class="mt-8"><i class="dot"></i>확인자</h5>
    <div class="writeGridContainer mt-4">
      <div>
        <div>관리책임자</div>
        <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_1 }}</p>
        <ml-input v-else v-model="form.inputA_1" :readonly="board.readonly"/>
      </div>
      <div>
        <div>서명</div>
        <sign-field v-if="!isPrint && !board.readonly" v-model="form.inputA_2" class="flex-1 justify-self-start sign-module" />
        <div v-else class="w-full flex-1 p-1">
          <img v-if="form.inputA_2" :src="form.inputA_2" width="100%" alt="Signature" class="signatureImg" />
          <div v-else class="signatureImg"></div>
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!--    관련서식-->
    <vs-row class="mt-6 mb-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 관련서식</h5>
      </vs-col>
    </vs-row>

    <file-upload-module id="formList" class="w-full mb-4" v-model="form.formList" :isPrint="isPrint" :readonly="board.readonly" :visible-title="false" :customTitle="true"></file-upload-module>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full" v-model="form.fileList" :isPrint="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
  <Print v-else :form="form" />
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import Print from "./Print.vue";
import SignField from "@/components/SignField.vue";
import * as inspectData from "./inspectData";

export default {
  components: { SignField, FieldSelectModule, PhotoUploadGridModule, FileUploadModule, TableInspectMerge, Print },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
        this.form.inspectionTitle = this.inspectionTitle;
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {

        value.summary = {
          안전보건점검_현장명: [],
          안전보건점검_점검표: [],
        };

        value.summary["안전보건점검_현장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["안전보건점검_점검표"].push({
          '건설현장 일반관리': 1,
        });

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        inspectionTitle: "청소·조도·통로 등",
        stdInfo: {},
        photoList: [],

        inputA_1: "",
        inputA_2: "",

        formList: [],
        fileList: [],
        inspectList: inspectData.inspectList,
      },
    };
  },
  created () {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
};
</script>
